/* AMTENDENCY — o painel da "Descrição" na PDP.

   Na referência a Descrição não é uma sanfona: o rótulo abre um painel branco
   que cobre a coluna de informação inteira, com o título em cima, um X no
   canto e o texto rolando por dentro. Fecha no X, no Esc e ao clicar fora.

   O painel é `position: absolute` ancorado na coluna (o CSS cuida disso). Ele
   NÃO usa o atributo `hidden`: `display: none` cortaria a transição de entrada
   (`translate3d(0,50px,0)` + fade), que é o que lá acontece. Quem esconde é
   `opacity`/`visibility`/`pointer-events` no CSS; aqui só entra e sai a classe
   de aberto, mais o `aria-hidden` para quem usa leitor de tela. */
(function () {
  var raiz = document.querySelector('[data-am-descricao]');
  if (!raiz) return;

  var abre = raiz.querySelector('[data-am-descricao-abre]');
  var painel = raiz.querySelector('[data-am-descricao-painel]');
  var fecha = raiz.querySelector('[data-am-descricao-fecha]');
  if (!abre || !painel) return;

  // o Liquid entrega o painel com `hidden` para quem está sem CSS/JS; a partir
  // daqui quem manda é a classe
  painel.removeAttribute('hidden');
  painel.setAttribute('aria-hidden', 'true');
  painel.setAttribute('tabindex', '-1');

  function aberto() {
    return painel.classList.contains('am-descricao__painel--aberto');
  }

  function mostra(sim) {
    painel.classList.toggle('am-descricao__painel--aberto', sim);
    painel.setAttribute('aria-hidden', String(!sim));
    abre.setAttribute('aria-expanded', String(sim));
    if (sim) {
      // o foco vai para o painel: quem navega por teclado não fica preso atrás
      painel.focus({ preventScroll: true });
    } else {
      abre.focus({ preventScroll: true });
    }
  }

  abre.addEventListener('click', function () {
    mostra(!aberto());
  });
  if (fecha) fecha.addEventListener('click', function () { mostra(false); });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && aberto()) mostra(false);
  });

  // clique fora: qualquer ponto que não seja o painel nem o próprio rótulo
  document.addEventListener('click', function (ev) {
    if (!aberto()) return;
    if (painel.contains(ev.target) || abre.contains(ev.target)) return;
    mostra(false);
  });
})();
